import { useCallback } from "react";
import { useToast } from "./Toast";

// ─────────────────────────────────────────────────────────────────────────────
// useNotify() — pont UNIQUE « message transitoire → Toast fixe ».
// ─────────────────────────────────────────────────────────────────────────────
// Remplace les dizaines de `notify()` locaux des écrans admin qui rendaient un
// <Alert> INLINE (lequel décalait le contenu — « ça bouge »). Ici, le message part
// dans la couche Toast globale (portal sur document.body, z-index max, auto-dismiss),
// donc AUCUN décalage de mise en page.
//
// Signature TOLÉRANTE (rétro-compatible avec les 5 variantes existantes) :
//   notify('Enregistré')                       → succès
//   notify('Erreur', true)                     → erreur   (2e arg booléen = isError)
//   notify('Erreur', false)                    → succès
//   notify('Attention', 'warning')             → 2e arg = type ('success'|'info'|'warning'|'error'|'ok')
//   notify('Créé', 'ok')                        → succès  ('ok' = alias succès, hérité)
//   notify('Info', { type: 'info' })            → 2e arg objet options { type }
//
// Renvoie une fonction STABLE (useCallback) → utilisable dans des deps d'effets.
const TYPE_ALIAS = { ok: "success", success: "success", info: "info", warning: "warning", warn: "warning", error: "error", err: "error" };

export default function useNotify() {
  const toast = useToast();
  return useCallback((message, arg) => {
    if (!message) return;
    let type = "success";
    if (arg === true) type = "error";
    else if (arg === false) type = "success";
    else if (typeof arg === "string") type = TYPE_ALIAS[arg.toLowerCase()] || "info";
    else if (arg && typeof arg === "object" && arg.type) type = TYPE_ALIAS[String(arg.type).toLowerCase()] || "info";
    // Repli défensif : si le provider n'est pas monté (tests, arbres isolés), on utilise
    // le pont global window.__toast, sinon on ne casse rien.
    const show = toast?.show || (typeof window !== "undefined" ? window.__toast : null);
    if (show) show({ type, message: String(message) });
  }, [toast]);
}
